RivalIQ.apps.Alerts.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgets = [
        {
            widgetId: RivalIQ.enums.widgetTypes.ALERTS,
            instanceId: 'alerts',
            // Force the single widget to always assert it's focus so we get both the curation
            // export cover page as well as the panel export sub titles
            isFocus: _.constant(true)
        }
    ];

    const Panel = RivalIQ.apps.Dashboard.views.DetailsLayout.extend({
        template: '#dashboardWidgetAlternateDetailLayoutTemplate',
        showLeftToolbarActions: _.noop,
        showToolbarActions: function () {
            const me = this;

            me.leftActions.show(new App.views.AlertFilter({
                dashboardModel: me.dashboardModel
            }));

            me.actions.show(new RivalIQ.views.Link({
                className: 'btn-link',
                linkName: 'Configure Alerts',
                attributes: {
                    href: '/settings#emailTab'
                }
            }));

            me.showExportDropdown();
        }
    });

    const Dashboard = RivalIQ.apps.Dashboard;
    curations.Alerts = Dashboard.models.SingleWidgetCuration.extend({
        title: 'Alerts',
        widgetsView: RivalIQ.apps.Dashboard.views.Widgets.extend({
            panelView: Panel
        }),
        widgetDefinitions: widgets
    });
});
